import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import {
	DateInput,
	PhoneInput,
	SelectInput
} from '../../../../../components/form-components/inputs.component'
import Yup from '../../../../../helpers/custom-yup'
import { checkAge } from '../../../../../helpers/time-check.helper'

const schema = Yup.object().shape({
	phone: Yup.string()
		.phone()
		.required('Informe o telefone'),
	birthday: Yup.string()
		.birthday()
		.required('Informe a data de nascimento')
		.test('valid-age', 'Data de nascimento inválida', checkAge)
})

const StyledForm = styled.div`
	padding-bottom: 25px;
	width: 300px;
	@media (max-width: 600px) {
		width: 100%;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

export default class ComplementaryForm extends Component {
	constructor(props) {
		super(props)
		this.phoneRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
	}

	componentWillMount() {
		const { birthday, gender, phone } = this.props.initialValues
		this.initialValues = { birthday, gender, phone }
	}

	render() {
		const { onSubmit } = this.props
		return (
			<Formik
				initialValues={this.initialValues}
				onSubmit={onSubmit}
				validationSchema={schema}
				ref={'form'}
				render={props => (
					<Form noValidate>
						<StyledForm>
							<DateInput
								elementRef={this.birthdayRef}
								id="birthday"
								label="Data de nascimento"
								{...props}
							/>
							{/* <StyledInputContainer>
								<SelectInput
									disabled
									elementRef={this.genderRef}
									id="gender"
									label="Sexo"
									placeholder="Selecione ..."
									options={[
										{ value: 'F', label: 'Feminino' },
										{ value: 'M', label: 'Masculino' },
										{ value: 'O', label: 'Outros' },
									]}
									multi={false}
									{...props}
								/>
							</StyledInputContainer> */}
							<StyledInputContainer>
								<PhoneInput
									elementRef={this.phoneRef}
									id="phone"
									label="Telefone *"
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
					</Form>
				)}
			/>
		)
	}
}

ComplementaryForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
